import env from '~/src/utils/env';

export const generateIdentityMigrationLinkUrl = () => {
  return `${env.apiUrl}/identity/migration-link`;
};
